module.exports = __webpack_public_path__ + "img/desc1.7bae38bc.jpg";